import React, { useEffect } from 'react';
import { AnalyticsProvider } from '@carvana/eventable-clickstream';
import ThemeProvider, { createGlobalStyle } from '@carvana/showroom-theme';
import { BrowserRouter } from 'react-router-dom';
import { MfeConfig } from '@carvana/microfrontend';
import { RegisterExperiment } from '@carvana/core-experiment';
import { datadogRum } from '@datadog/browser-rum';
import { getMyCarsReskinBucket } from '@utils/myCarsReskinExperiment';
import { Analytics as AnalyticsConst, Experiments, AnalyticEvents } from '../../constants';
import ScrollToTop from '../_common/scroll-to-top/ScrollToTop';
import { useAppState } from '../../store/State';
import { Analytics } from '../../services/analytics-service';
/* @carvana/showroom-css-theme */
import '@carvana/showroom-css-theme/Theme.css';
import '@carvana/showroom-css-theme/Reset.css';
import '@carvana/showroom-css-theme/Font.css';
import '@carvana/showroom-forms/index.css';
import '@carvana/showroom-accordion/index.css';
import '@carvana/showroom-modal/index.css';
import '@carvana/core-helios/index.css';
import '@carvana/core-helios/fonts.css';
import '@carvana/core-helios-forms/index.css';
import '@carvana/core-helios-modal/index.css';
import '@carvana/core-helios-button/index.css';
import '@carvana/core-helios-loader/index.css';

import { GlobalCss } from './GlobalCss';
import theme from '../../theme';
import Routes from './Routes';
import microfrontendConfiguration from './microfrontend.config';
/* @carvana/showroom-css-theme - end */

//  createGlobalStyle method takes -- 'development' | 'test' | 'uat' | 'production' | 'prod' -- as env's
const GlobalStyles = createGlobalStyle(process.env.NODE_ENV, null as any);
//  AnalyticsProvider.environment (below) takes -- 'dev' | 'test' | 'uat' | 'production' -- as env's
const environment = process.env.NODE_ENV === 'development' ? 'dev' : process.env.NODE_ENV;

RegisterExperiment({
  environment: process.env.NODE_ENV,
  projectName: AnalyticsConst.PROJECT_NAME,
  isLocalInstance: process.env.LOCAL === 'true',
  shouldBucket(experimentName: string) {
    const { userAgent } = navigator || {};
    if (experimentName === Experiments.CORE_SERVICE_AND_REPAIRS && window?.location?.pathname === '/my-carvana/') {
      return false;
    }

    return true;
  },
  onExperimentUpdate({ experiment, identifier }) {
    const exp = experiment[Experiments.CORE_SERVICE_AND_REPAIRS];
    if (exp !== undefined) {
      Analytics.trackEvent(AnalyticEvents.sarExperiment, {
        bucket: exp.assignedBucket,
        identifier,
      });
      datadogRum.addAction(AnalyticEvents.sarExperiment, {
        bucket: exp.assignedBucket,
        identifier,
      });

      return;
    }

    datadogRum.addAction(AnalyticEvents.ovpExperiment, {
      name: experiment.name,
      bucket: experiment.assignedBucket,
      identifier,
    });
  },
});

useAppState();

const App = () => {
  useEffect(() => {
    MfeConfig(microfrontendConfiguration);
  }, []);

  return (
    <AnalyticsProvider
      environment={environment as any}
      projectName={AnalyticsConst.PROJECT_NAME}
      track={AnalyticsConst.TEAM_NAME}
      payloadMetaAttributes={{ myCarsReskinBucket: getMyCarsReskinBucket() }}
    >
      <ThemeProvider theme={theme}>
        <GlobalStyles />
        <GlobalCss />
        <BrowserRouter>
          <ScrollToTop>
            <Routes />
          </ScrollToTop>
        </BrowserRouter>
      </ThemeProvider>
    </AnalyticsProvider>
  );
};

export default App;
